import React, { Component } from 'react';

import ParkinglocationSelect from './ParkinglocationSelect';

import { Form, Input, InputNumber, Button, Modal, Select, Divider, Switch, Icon } from 'antd';
import { withState } from 'recompose';
const FormItem = Form.Item;
class TrafficSignsSettingsForm extends Component {

  state = {
    modalVisible: false
  }

  form = null;

  componentWillReceiveProps(nextProps) {
    this.setState({
      modalVisible: nextProps.modalVisible
    });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.props.onSuccess(this.props.form, values);
      }
    });
  }

  renderForm() {
    const { getFieldDecorator } = this.props.form;

    // if (this.props.initValues !== undefined && this.props.initValues !== null) {
    //   this.props.form.setFields(this.props.initValues);
    // }

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 },
      },
    };

    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    return (
      <Form onSubmit={this.handleSubmit} ref={ref => { this.form = ref }}>
        <FormItem
          {...formItemLayout}
          label="Lokalita" >
          {getFieldDecorator('coreParkingLocationId', {
            initialValue: this.props.initialValues && this.props.initialValues.coreParkingLocationId
              ? this.props.initialValues.coreParkingLocationId
              : undefined,
          })(
            <ParkinglocationSelect onChange={(value) => { this.props.form.setFieldsValue({ coreParkingLocationId: value }); }} />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Typ značky" >
          {getFieldDecorator('type', {
            initialValue: this.props.initialValues && this.props.initialValues.type
              ? this.props.initialValues.type
              : "undefined",
          })(
            <Select
              onChange={(value) => {
                this.props.form.setFieldsValue({ type: value });
              }}>
              <Select.Option value="undefined">Nenastaveno</Select.Option>
              <Select.Option value="matrix">Maticová</Select.Option>
              <Select.Option value="mechanical">Mechanická</Select.Option>
              <Select.Option value="ledSegments">LED segmenty</Select.Option>
              {/* <Select.Option value="ledSegmentsTCP">LED segmenty TCP</Select.Option> */}
            </Select>
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Popis">
          {getFieldDecorator('description', {
            initialValue: this.props.initialValues && this.props.initialValues.description
              ? this.props.initialValues.description
              : null,
          })(
            <Input.TextArea autosize={{ minRows: 2, maxRows: 4 }} />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Událost" >
          {getFieldDecorator('eventListener', {
            initialValue: this.props.initialValues && this.props.initialValues.eventListener
              ? this.props.initialValues.eventListener
              : null,
            rules: [{
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <Input />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Schéma" >
          {getFieldDecorator('defaultSettings.textPattern', {
            initialValue: this.props.initialValues && this.props.initialValues.defaultSettings && this.props.initialValues.defaultSettings.textPattern
              ? this.props.initialValues.defaultSettings.textPattern
              : null,
            rules: [{
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <Input.TextArea
              autosize={{
                maxRows: 7
              }} />
          )}
        </FormItem>
        <Divider />
        <FormItem
          {...formItemLayout}
          label="Barva pozadí" >
          {getFieldDecorator('defaultSettings.backgroundColor', {
            initialValue: this.props.initialValues && this.props.initialValues.defaultSettings && this.props.initialValues.defaultSettings.backgroundColor
              ? this.props.initialValues.defaultSettings.backgroundColor
              : null,
            rules: [{
              required: true, message: 'Zadejte prosím tuto položku!',
            }],
          })(
            <Select
              onChange={(value) => {
                this.props.form.setFieldsValue({ color: value });
              }}>
              <Select.Option value="K"><span style={{ height: 10, width: 10, backgroundColor: 'black', borderRadius: '50%', display: 'inline-block' }}></span>{' '}Black</Select.Option>
              <Select.Option value="W"><span style={{ height: 10, width: 10, backgroundColor: 'white', borderRadius: '50%', display: 'inline-block', border: '1px solid #bbb' }}></span>{' '}White</Select.Option>
              <Select.Option value="R"><span style={{ height: 10, width: 10, backgroundColor: 'red', borderRadius: '50%', display: 'inline-block' }}></span>{' '}Red</Select.Option>
              <Select.Option value="G"><span style={{ height: 10, width: 10, backgroundColor: 'green', borderRadius: '50%', display: 'inline-block' }}></span>{' '}Green</Select.Option>
              <Select.Option value="B"><span style={{ height: 10, width: 10, backgroundColor: 'blue', borderRadius: '50%', display: 'inline-block' }}></span>{' '}Blue</Select.Option>
              <Select.Option value="C"><span style={{ height: 10, width: 10, backgroundColor: 'cyan', borderRadius: '50%', display: 'inline-block' }}></span>{' '}Cyan</Select.Option>
              <Select.Option value="M"><span style={{ height: 10, width: 10, backgroundColor: 'magenta', borderRadius: '50%', display: 'inline-block' }}></span>{' '} Magenta</Select.Option>
              <Select.Option value="Y"><span style={{ height: 10, width: 10, backgroundColor: 'yellow', borderRadius: '50%', display: 'inline-block' }}></span>{' '}Yellow</Select.Option>
            </Select>
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Barva textu" >
          {getFieldDecorator('defaultSettings.color', {
            initialValue: this.props.initialValues && this.props.initialValues.defaultSettings && this.props.initialValues.defaultSettings.color
              ? this.props.initialValues.defaultSettings.color
              : null,
            rules: [{
              required: true, message: 'Zadejte prosím tuto položku!',
            }],
          })(
            <Select
              onChange={(value) => {
                this.props.form.setFieldsValue({ color: value });
              }}>
              <Select.Option value="K"><span style={{ height: 10, width: 10, backgroundColor: 'black', borderRadius: '50%', display: 'inline-block' }}></span>{' '}Black</Select.Option>
              <Select.Option value="W"><span style={{ height: 10, width: 10, backgroundColor: 'white', borderRadius: '50%', display: 'inline-block', border: '1px solid #bbb' }}></span>{' '}White</Select.Option>
              <Select.Option value="R"><span style={{ height: 10, width: 10, backgroundColor: 'red', borderRadius: '50%', display: 'inline-block' }}></span>{' '}Red</Select.Option>
              <Select.Option value="G"><span style={{ height: 10, width: 10, backgroundColor: 'green', borderRadius: '50%', display: 'inline-block' }}></span>{' '}Green</Select.Option>
              <Select.Option value="B"><span style={{ height: 10, width: 10, backgroundColor: 'blue', borderRadius: '50%', display: 'inline-block' }}></span>{' '}Blue</Select.Option>
              <Select.Option value="C"><span style={{ height: 10, width: 10, backgroundColor: 'cyan', borderRadius: '50%', display: 'inline-block' }}></span>{' '}Cyan</Select.Option>
              <Select.Option value="M"><span style={{ height: 10, width: 10, backgroundColor: 'magenta', borderRadius: '50%', display: 'inline-block' }}></span>{' '} Magenta</Select.Option>
              <Select.Option value="Y"><span style={{ height: 10, width: 10, backgroundColor: 'yellow', borderRadius: '50%', display: 'inline-block' }}></span>{' '}Yellow</Select.Option>
            </Select>
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Zarovnání" >
          {getFieldDecorator('defaultSettings.aligment', {
            initialValue: this.props.initialValues && this.props.initialValues.defaultSettings && this.props.initialValues.defaultSettings.aligment
              ? this.props.initialValues.defaultSettings.aligment
              : null,
            rules: [{
              required: true, message: 'Zadejte prosím tuto položku!',
            }],
          })(
            <Select
              onChange={(value) => {
                this.props.form.setFieldsValue({ color: value });
              }}>
              <Select.Option value="L">Zleva</Select.Option>
              <Select.Option value="C">Na střed</Select.Option>
              <Select.Option value="R">Zprava</Select.Option>
            </Select>
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Platnost zprávy" >
          {getFieldDecorator('defaultSettings.duration', {
            initialValue: this.props.initialValues && this.props.initialValues.defaultSettings
              ? this.props.initialValues.defaultSettings.duration
              : null,
            rules: [{
              type: 'integer', message: 'Položka musí obsahovat číslo!',
            }, {
              required: true, message: 'Zadejte prosím tuto položku!',
            }],
          })(
            <InputNumber
              min={0}
              max={1440} />
          )}
        </FormItem>
        <Divider />
        <FormItem
          {...formItemLayout}
          label="Aktivní" >
          {getFieldDecorator('active', {
            valuePropName: 'checked',
            initialValue: this.props.initialValues && this.props.initialValues.active
              ? this.props.initialValues.active
              : false,
          })(
            <Switch
              checkedChildren={<Icon type="check" />}
              unCheckedChildren={<Icon type="close" />} />
          )}
        </FormItem>
        <FormItem {...tailFormItemLayout}>
          <Button type="primary" htmlType="submit">Uložit</Button>
        </FormItem>

      </Form>
    );
  }

  render() {
    if (this.props.type && this.props.type === 'modal') {
      return (
        <Modal
          width={700}
          title="Nastavení informační tabule"
          visible={this.state.modalVisible}
          maskClosable={false}
          onCancel={() => {
            this.props.onModalCancel(this.props.form);
            this.setState({ modalVisible: false });
          }}
          onSubmit={this.handleSubmit} >
          {this.renderForm()}
        </Modal>
      )
    } else {
      return this.renderForm();
    }
  }
}

const WrappedParkinglocationForm = Form.create()(TrafficSignsSettingsForm);

export default WrappedParkinglocationForm;


// WEBPACK FOOTER //
// ./src/components/TrafficSignsSettingsForm.js